export default __webpack_public_path__ + "static/media/bgImage.3e29d5e1.png";